const moment = require('moment');

const isInternalUrl = (url) => /^\/(?!\/)/.test(url);

const getBlogPostDateSlug = (page) =>
  page ? moment(page.acf.publish_date, 'DD/MM/YYYY').format('YYYY/MM') : '';

const getPageSlug = (page) =>
  page && page.acf.slug !== '/' ? page.acf.slug : '';

const getLanguageSlug = (language) =>
  (language.path || '');

const getPageSlugType = ({ type, page, parent }) => {
  switch (type) {
    case 'websites':
      return '/';
    case 'casestudies':
      return `/${parent.acf.slug}/`;
    case 'blogposts':
      return `/${parent.acf.slug}/${getBlogPostDateSlug(page)}/`;
  }
};

const getPageUrlForType = ({ type = 'websites', language, page, parent }) =>
  getLanguageSlug(language) + getPageSlugType({ type, language, page, parent }) + getPageSlug(page);

const getBlogUrl = ({ language, page, parent }) =>
  getPageUrlForType({ type: 'blogposts', language, page, parent });

const getCaseStudyUrl = ({ language, page, parent }) =>
  getPageUrlForType({ type: 'casestudies', language, page, parent });

const getTypeformUrl = ({ language, type, typeforms }) =>
  typeforms.find(typeform => type === typeform.type && language.locale === typeform.locale).url;

module.exports = {
  getPageUrlForType,
  getBlogUrl,
  getCaseStudyUrl,
  getTypeformUrl,
  isInternalUrl
};